import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * Interceptor manager
 */
export class InterceptorManager {
  constructor() {
    _defineProperty(this, "handlers", []);
  }
  /**
   * Add interceptor
   */
  use(fulfilled, rejected) {
    this.handlers.push({
      fulfilled,
      rejected
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove interceptor
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors
   */
  clear() {
    this.handlers.length = 0;
  }

  /**
   * Iterate over all interceptors
   */
  forEach(fn) {
    this.handlers.forEach(h => {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/**
 * Request interceptor manager
 */
export class RequestInterceptorManager extends InterceptorManager {}

/**
 * Response interceptor manager
 */
export class ResponseInterceptorManager extends InterceptorManager {}

/**
 * Execute request interceptor chain
 */
export function runRequestInterceptors(_x, _x2) {
  return _runRequestInterceptors.apply(this, arguments);
}

/**
 * Execute response interceptor chain
 */
function _runRequestInterceptors() {
  _runRequestInterceptors = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(interceptors, config) {
    var promise;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          promise = Promise.resolve(config);
          interceptors.forEach(interceptor => {
            promise = promise.then(config => interceptor.fulfilled(config), error => {
              if (interceptor.rejected) {
                return interceptor.rejected(error);
              }
              return Promise.reject(error);
            });
          });
          return _context.abrupt("return", promise);
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _runRequestInterceptors.apply(this, arguments);
}
export function runResponseInterceptors(_x3, _x4) {
  return _runResponseInterceptors.apply(this, arguments);
}
function _runResponseInterceptors() {
  _runResponseInterceptors = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(interceptors, response) {
    var promise;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          promise = Promise.resolve(response);
          interceptors.forEach(interceptor => {
            promise = promise.then(response => interceptor.fulfilled(response), error => {
              if (interceptor.rejected) {
                return interceptor.rejected(error);
              }
              return Promise.reject(error);
            });
          });
          return _context2.abrupt("return", promise);
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _runResponseInterceptors.apply(this, arguments);
}